import { Clock } from "@assets/Icons";
import useDiscountCountdown from "@hooks/useDiscountCountdown";
import styles from './styles.module.scss';

export const OfferEnds = () => {
  const {
    time: { displayMinutes, displaySeconds },
    isTimeUp,
  } = useDiscountCountdown();

  return isTimeUp ? null : (
    <div className={styles.offer}>
      <Clock /> THIS OFFER ENDS IN {displayMinutes}:{displaySeconds} MIN
    </div>
  );
};
